import {RefObject, useCallback, useLayoutEffect, useState} from 'react';

import useOnScreenResize from '~/shared/hooks/useOnScreenResize';

const useLineStyles = (elsRefs: RefObject<(HTMLElement | null)[]>, currentIndex: number) => {
  const [lineStyle, setLineStyle] = useState({left: 0, width: 0, isReady: false});

  const setLineStyles = useCallback(() => {
    const node = elsRefs.current?.[currentIndex];
    if (!node) {
      return;
    }

    const {offsetLeft, offsetWidth} = node;
    setLineStyle({left: offsetLeft, width: offsetWidth, isReady: true});
  }, [elsRefs, currentIndex]);

  useLayoutEffect(() => {
    setLineStyles();
  }, [setLineStyles]);

  useOnScreenResize(setLineStyles);

  return lineStyle;
};

export default useLineStyles;
